export const INITIAL = {
	MODAL: {
		content: '',
		data: {}
	},
	VALUES: {
		name: '',
		description: '',
	},
	LIST: {
		columns: {
			name: 'Personagem',
			description: 'Descrição',
		},
		rows: [],
	},
}